import {
  createContext,
  createElement,
  useContext,
  type ReactElement,
  type ReactNode
} from 'react';
import type { VendorSession } from '~/models/VendorSession';

const VendorSessionContext = createContext<VendorSession | null>(null);

type ProviderProps = {
  session: VendorSession;
  children: ReactNode;
};

export const VendorSessionProvider = ({
  session,
  children
}: ProviderProps): ReactElement =>
  createElement(VendorSessionContext.Provider, { value: session }, children);

export const useVendorSessionContext = (): VendorSession =>
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  useContext(VendorSessionContext)!;
